import React from 'react';
import '../../terms-conditions-policies.scss';

const PrivacyPolicy = () => (
  <section className="privacy-policy-cont">
    <article className="tcp-section-header">
      <h1>Privacy Policy</h1>
      <p>
        Your privacy is important to us at Leegality. We respect your privacy regarding any
        information we may collect from you across our website.
      </p>
    </article>
    <article className="tcp-section-body">
      <p>
        This Privacy Policy (“Privacy Policy”) describes Grey Swift Private Limited’s (“Company”), a
        company incorporated under the laws of India with CIN U74999HR2016PTC066380 with its
        registered office at GH-2, Sector-6, Mansa Devi Complex, Panchkula, Haryana, India: 134 114,
        policies and procedures on the collection, use and disclosure of a User’s information
        pursuant to a User’s use of the services provided by the Company, whether existing now or in
        future. The Company is committed to ensuring that any use or sharing of your information
        with anyone shall be one only in accordance with the procedures described in this Privacy
        Policy.
      </p>
      <p>
        The capitalized terms used in this Privacy Policy, but not defined in this Privacy Policy,
        shall have the meaning given to such terms in the Terms of Services (defined hereinafter).
      </p>
      <p>
        Please read this Privacy Policy before using the site, the application or submitting any
        personal information. Where any person uses or accesses the Website of the Company or uses
        any products or services of the Company or otherwise provides any User Information
        (including information in relation to other persons) (“User”), the User consents to the
        collection and use of the information disclosed on the Website or in the use of the services
        in accordance with this Privacy Policy, including but not limited to the User’s consent for
        collecting, using, sharing and disclosing information of the User as per this Privacy
        Policy.
      </p>
      <p>
        Please also note that the Privacy Policy will also apply to information of Users supplied by
        other Users. In case of information of Users supplied by other Users, the User providing the
        information confirms and warrants that the User has the authority to provide the necessary
        User Information.
      </p>

      <ol className="tcp-main-ol">
        <li>
          <span className="tcp-section-item-header">Other applicable terms</span>
          <p>
            This Privacy Policy is a part of and incorporated within, and is to be read along with
            the Terms of Service (the “Terms of Service”) which are available at
            <a href="https://www.leegality.com/"> https://www.leegality.com/</a>
            .
          </p>
        </li>
        <li>
          <span className="tcp-section-item-header">Policy changes</span>
          <p>
            The Company may change and update this Privacy Policy from time to time. Such changes
            may be made without prior notice. The User is encouraged to review this Privacy Policy
            before accessing any services provided by the Company to make sure that the User
            understand how any personal information provided by the User will be used.
          </p>
        </li>
        <li>
          <span className="tcp-section-item-header">Links to other websites</span>
          <p>
            The procedures and practices set forth in this Privacy Policy describe the use and
            disclosure of User Information collected by the Company. The application, website and/or
            other platforms of the Company, as available (“Products”) may contain links to other
            websites. Any personal information about the User collected which such User visits such
            websites is not governed by this Privacy Policy. The User is encouraged to exercise
            caution and review the privacy policies applicable to such websites before accessing
            them. The User acknowledges that the Company shall not be responsible for and has no
            control over the practices and content of any website accessed using the links contained
            on the Products.
          </p>
        </li>
        <li>
          <span className="tcp-section-item-header">Competency to contract</span>
          <p>
            By agreeing to this Privacy Policy, a User (which such User is a natural Person)
            represents that the User is at least the age of majority i.e. 18 years, and is competent
            to contract. Additionally, where the User is registering on behalf of, and is the
            authorized representative of, a company, partnership or any other legal entity, such
            User has been duly authorized by such entity and is permitted under Applicable Laws to
            accept these Terms of Service. In case the User is a natural Person who is not of the
            age of majority or is not competent to contract, the User may not use the services of
            the Company, the Products or provide any information to the Company.
          </p>
        </li>
        <li>
          <span className="tcp-section-item-header">Collection of information</span>
          <p>
            The Company collects two basic types of information from a User in conjunction with a
            User’s use of the Products i.e. personal information, which is any information that
            exclusively identifies a User (e.g., the User’s name, email address, telephone number
            amongst others) and non-personal information, which is information that does not
            exclusively identify a User but is related to you nonetheless such as, information about
            a User’s interests, demographics and use of the sites. The Company may also receive
            personal information regarding a User as shared by third parties who maybe our clients
            or otherwise avail service from the Company. Please note that in such instances the
            Company is acting on the instructions provided by such client or user and the Company
            does not separately verify the right of the client or user to provide User Information
            to the Company. In case you are not the intended recipient of the services and Products,
            you should contact the Company at the earliest.
          </p>
          <p>
            Towards the provision of the services by the Company and the use of the Products, the
            Company shall in addition to the information described above, collect the following
            information from a User (“User Information”):
          </p>
          <table>
            <tr>
              <td>
                Location
              </td>
              <td>
                Information about the location of the User’s device used to access the services from
                the Company. This is used for the provision of the services, for maintenance of
                records for audit purposes and other matters.
              </td>
            </tr>
            <tr>
              <td>Access information</td>
              <td>
                Passwords and other details required to access or use the services provided by the
                Company.
              </td>
            </tr>
            <tr>
              <td>Personal information</td>
              <td>
                Information about the name, email address, contact information and details of
                official documents. This is used for the provision of the services and for
                maintenance of records for audit purposes.
              </td>
            </tr>
            <tr>
              <td>Camera and video</td>
              <td>
                Image and video information is stored for the provision of services and
                verification purposes.
              </td>
            </tr>
            <tr>
              <td>Other applications</td>
              <td>
                The User’s use of other software or applications which are linked or used in the
                provision of the services e.g. any third party sites though which a User may have
                accessed the services.
              </td>
            </tr>
            <tr>
              <td>Automated collection</td>
              <td>
                Details of the User’s device, computer and device information, activity on the
                website and other similar information. The Company collects this information for
                analytics, improvement of the services and for review purposes.
              </td>
            </tr>
            <tr>
              <td>Digital signature details</td>
              <td>
                Digital signature certificate information including name, address received after
                successful certificate generation.
              </td>
            </tr>
            <tr>
              <td>Stamp duty</td>
              <td>Stamp duty related information.</td>
            </tr>
            <tr>
              <td>Others</td>
              <td>As may be explicitly required & requested from time to time.</td>
            </tr>
          </table>
          <p>
            Further, upon registering on the Products, the User may from time to time choose to
            provide payment related financial information (credit card, debit card, bank account
            details, billing address etc.) which will be retained by the relevant payment system or
            payment service provider in accordance with Applicable Laws. The Company ensures that
            such data/information is only transacted over secure sites of approved payment gateways
            which employ substantial degree of care available under the technology presently in use.
          </p>
          <p>
            The Company may use and store some sensitive information including OTPs, secret keys and
            access keys for document sharing etc. to enable the User to avail the Company’s
            services.
          </p>
          <p>
            The Company does not store any kind of biometric information/OTP used for authentication
            for an Aadhaar eKYC or Aadhaar eSign Transaction. Biometrics required for Aadhaar
            authentication are captured directly by the Certifying Authority, are encrypted right at
            the time when they are obtained and are processed only for the particular transactions
            for which they are collected. Strict guidelines laid down by UIDAI for biometric
            authentication are followed by Certifying Authority. The compliance of the Company’s
            products with governmental guidelines, as mandatory, is regularly audited by independent
            third-party information security auditors appointed by CERT-IN, MEITY, Govt. of India.
          </p>
        </li>
        <li>
          <span className="tcp-section-item-header">Usage of User Information</span>
          <p>
            In addition to the uses specified above, User Information is used by the Company that
            the Company considers necessary for achieving a seamless, efficient and safe experience,
            customized to a User’s needs and use the personal information to provide services to a
            User, enhance the operation of the Products, improve the Company’s marketing and
            promotional efforts, analyse the usage of the Products, improve the Company’s product
            offerings, to personalise the User’s experience and to provide the User with a better
            experience.
          </p>
        </li>
        <li>
          <span className="tcp-section-item-header">Storage of User Information</span>
          <p>
            Storage and transfer of User Information is carried out in compliance with all
            Applicable Laws, including without limitation, the Information Technology Act, 2000 and
            the Information Technology (Reasonable security practices and procedures and sensitive
            personal data or information) Rules, 2011.
          </p>
          <p>
            Please note that the Company’s information security practices constitute reasonable
            security measures, including as mentioned in Information Technology Act, 2000 in place
            to protect the loss or misuse of the User Information. The Company follows ISO/IEC 27001
            Information Security Management System Standard to handle and secure the information
            dealt by us. Compliance with the same is regularly audited by an independent third-party
            information security auditor appointed by CERT-IN, MEITY, Govt. of India. Within the
            contours of the Company’s ISO 27001 compliant Information Security Policies, the Company
            follows a strict internal access control policy which is highly controlled and heavily
            monitored. Any kind of access is only provided after the necessary approvals and on a
            strict ‘need to know’ basis.
          </p>
          <p>
            Whenever a User changes or accesses the User’s account information, the Company offers
            the use of a secure server. However, the User acknowledges that transacting over the
            internet has inherent risks which can only be avoided by the User following reasonable
            security practices, such as not revealing account/login related information to any other
            person and informing the Company’s customer care team about any suspicious activity or
            where the User’s account has/may have been compromised.
          </p>
          <p>
            Please note that the Company does not guarantee that there will be no unintended
            disclosures of the User Information and data provided by a User on account of a data
            breach, unauthorized access, security failure etc. the Company cannot guarantee, gives
            no warranties, and shall not be liable for breach of the security of User Information
            through the services of the Company due to malicious attacks, errors, commission or
            omissions not wilfully initiated by the Company and any transmission is at the risk of
            the User.
          </p>
          <p>
            All kinds of information collected is stored in a completely secure method following
            practices such as instance isolation, one way hashing algorithms, symmetric and
            asymmetric encryption techniques with master. Different Levels of protection and
            security is followed depending on the nature of information being protected.
          </p>
        </li>
        <li>
          <span className="tcp-section-item-header">Dissemination of User Information</span>
          <p>
            Where any service requested by a User involves a third party, such information as is
            reasonably necessary by the Company to carry out the User’s service request may be
            shared with such third party and the Company may also obtain details and information
            from the third party on usage. The Company may also engage with other companies/ persons
            to perform functions such as order fulfilment, delivering packages, analyzing data,
            providing marketing assistance, providing search results and links (including paid
            listings and links), processing payments, and providing customer service. The User
            understand that they have access to personal information needed to perform their
            functions.
          </p>
          <p>
            Additionally, User Information may be shared by the Company with a third-party business
            entity in case of any proposed merger, acquisition or re-organization, amalgamation,
            restructuring of business. Should such a transaction occur that other business entity
            (or the new combined entity) will be required to follow this Privacy Policy with respect
            to your personal information.
          </p>
          <p>
            The Company may be required to disclose any information that is lawfully sought from it
            by a judicial or other competent body pursuant to applicable laws.
          </p>
          <p>
            Do note that the Company may anonymize and/or de-identify information collected from
            the Users. The Company’s use and disclosure of aggregated and/or de-identified
            information is not restricted by this Privacy Policy and it may be used and disclosed to
            others without limitation.
          </p>
        </li>

        <li>
          <span className="tcp-section-item-header">Retention of User Information</span>
          <p>
            The Company may, at its discretion, retain any User Information for as long as it is
            reasonably required or as required under Applicable Laws or, in case of a Aadhaar based
            eSign, as specified by the Controller of Certifying Authorities or the eSign Service
            Provider. The Company shall not automatically destroy any User Information after the
            closure or termination of a User’s account with the Company.
          </p>
        </li>

        <li>
          <span className="tcp-section-item-header">Communication policy</span>
          <p>
            When the User sets up an account or receives any request pursuant to the provision of
            the services, the User is deemed to have opted in to receive emails and messages from
            the Company and its service providers. While you may opt out of promotional messages,
            you cannot opt out of receiving certain administrative, financial, technical and legal
            information from the Company in connection with the services.
          </p>
        </li>
        <li>
          <span className="tcp-section-item-header">Alteration of User Information</span>
          <p>
            In case the User requests any change or deletion of User Information of the User, or
            permanently delete the User’s, the User must contact the Company at
            support@leegality.com or contact the Data Protection and Grievance Officer. Do note that
            the Company is not obligated to alter or vary or delete any User Information which it is
            required to maintain under applicable laws or pursuant to contractual requirements of
            the Company.
          </p>
        </li>
        <li>
          <span className="tcp-section-item-header">Cookie policy</span>
          <p>
            A “cookie” is a packet of information stored on a browser by a server so it can be
            later read back. When you return to the website or application or access it though
            another website – they recognise these cookies and therefore your browsing device. To
            improve the user experience of the site or application for the Users, understand how
            Users use our website, personalize content and show promotional content/ advertisements
            the Company may use “cookies”, or similar electronic tools to collect information. This
            information may include the URL that User just came from (whether this URL is on the
            Company’s website or not), which URL that the User next goes to (whether this URL is on
            the Company’s website or not), the User’s computer and mobile browser information, the
            User’s IP address, and other information associated with your interaction with the
            Products. Note that information and data provided by a User may be collected in a
            “cookie” if the User has previously provided such information and data.
          </p>
        </li>
        <li>
          <span className="tcp-section-item-header">Local storage policy</span>
          <p>
            To facilitate the provision of services by the Company to the User, the Company may
            store information locally on the device of the User. The User consents to the local
            storage of information on the device of the User for the facilitation of the services by
            the Company.
          </p>
        </li>
        <li>
          <span className="tcp-section-item-header">Legal requirements</span>
          <p>
            Please note that the Company is incorporated in India and Company operates in
            accordance with Indian laws. Except as specified in this Privacy Policy, the Company
            does not warrant or confirm that this Privacy Policy conforms to any laws other than the
            laws applicable in the Republic of India. Except as specified in the Terms of Service or
            as agreed with the Company in writing, in case any User is subject to any legal
            requirements in relation to User Information which are inconsistent or in conflict with
            the requirements under the laws in the Republic of India or this Privacy Policy, which
            legal requirements would become applicable to the Company by the use of the Products by
            the User or the provision of User Information, the User is restricted from using the
            Products and the Company does not assume any legal liability or compliances by virtue of
            the same.
          </p>
          {' '}
          <p>
            All disputes under this Privacy Policy shall be resolved by final and binding
            arbitration by a sole arbitrator under the Arbitration and Conciliation Act, 1996. The
            sole arbitrator shall be appointed by the mutual consent of the User and the Company.
            The
            language of the arbitration shall be English and the seat of arbitration shall be
            Gurgaon,
            Haryana.
          </p>
        </li>
        <li>
          <span className="tcp-section-item-header">Contact details</span>
          <p>
            In case a User has any queries or any discrepancies / grievances with respect to the
            User Information provided by a User, please contact the Company’s Data Protection and
            Grievance Officer by writing at:
          </p>
          <p>
            <b>Name: </b>
            Mr. Prakhar Agarwal
            <br />
            <b>Email Address: </b>
            support@leegality.com
            <br />
            <b>Address: </b>
            Plot no.444, Phase III, Udyog Vihar, Sector 18, Gurugram, Haryana 122022
          </p>
        </li>
        <li>
          <span className="tcp-section-item-header">Updates to the Privacy Policy</span>
          <p>
            The Company reserves the right, at any time, to add to, change, update, or modify this
            Privacy Policy. The latest Privacy Policy will be available on this page.
          </p>
        </li>
      </ol>
    </article>
  </section>
);

PrivacyPolicy.propTypes = {};

PrivacyPolicy.defaultProps = {};

export default PrivacyPolicy;
